import { schema } from 'normalizr';

// SCHEMAS
const region = new schema.Entity('regions');
const hotel = new schema.Entity('hotels');
const hotelPromotion = new schema.Entity('hotelPromotions');
const hotelRoom = new schema.Entity('hotelRooms');
const hotelPicture = new schema.Entity('hotelPictures');
const destination = new schema.Entity('destinations');
const destinationPicture = new schema.Entity('destinationPictures');
const alternativeAttribute = new schema.Entity('alternativeAttributes');

const company = new schema.Entity('companies');
const hotelReview = new schema.Entity('hotelReviews');

const member = new schema.Entity('members');
const user = new schema.Entity('users');
const memberEmail = new schema.Entity('memberEmails');
const memberPhone = new schema.Entity('memberPhones');
const userEmail = new schema.Entity('userEmails');
const userPhone = new schema.Entity('userPhones');


// RELATIONS
hotel.define({
    alternativeAttributes: [alternativeAttribute],
    destination,
    hotelPictures: [hotelPicture],
    hotelRooms: [hotelRoom],
    hotelValidPromotions: [hotelPromotion],
});

hotelRoom.define({
    hotel,
});

destination.define({
    alternativeAttributes: [alternativeAttribute],
    destinationPictures: [destinationPicture],
    destinations: [destination],
    hotels: [hotel],
    region,
});

region.define({
    alternativeAttributes: [alternativeAttribute],
    destinations: [destination],
});

hotelPromotion.define({
    hotelPromotion,
});

hotelReview.define({ hotel });

member.define({
    travelAgency: company,
    parent: member,
    user,
    memberEmails: [memberEmail],
    memberPhones: [memberPhone],
});

user.define({
    alternativeUser: user,
    userEmails: [userEmail],
    userPhones: [userPhone],
});


// EXPORTS
export const hotelSchema = hotel;
export const hotelRoomSchema = hotelRoom;
export const regionSchema = region;
export const destinationSchema = destination;
export const hotelPromotionSchema = hotelPromotion;
export const memberSchema = member;
export const userSchema = user;
